import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import templateUrl from 'emun.customer/customer-note-prompt.htm'
import config from 'emun.customer/customer.config'

function CustomerNotePromptController($rootScope, $uibModalInstance, options) {
    var $ctrl = this;
    var model = $ctrl.model = options.model;
    var bus = $ctrl.bus = new ServiceBus($rootScope);
    $ctrl.title = model.prospectmode ? 'PROSPECT NOTE' : model.locationmode ? 'LOCATION NOTE' : 'CUSTOMER NOTE...';
    $ctrl.config = config;
	if (options.title) {
		$ctrl.title = options.title;
	}


    if ($ctrl.model.note.retailerId) {
        if ($ctrl.model.prospectmode) {
            $ctrl.retailerQuery = new AutoQuery({
                url: 'QueryProspects.json?Id=' + $ctrl.model.note.retailerId,
                orderBy: 'CompanyName',
                autoLoad: true,
                onLoaded: args => {$ctrl.model.customer = args.first;}
            });
        } else if ($ctrl.model.locationmode) {
            $ctrl.retailerQuery = new AutoQuery({
                url: 'QueryRetailerShippingLocations.json?Id=' + $ctrl.model.note.retailerId,
                orderBy: 'Name',
                autoLoad: true,
                onLoaded: args => {
                    $ctrl.model.customer = args.first;
                    $ctrl.model.customer.retailerId = $ctrl.model.customer.id;
                }
            });
        }else {
            $ctrl.retailerQuery = new AutoQuery({
                url: 'QueryRetailers.json?Id=' + $ctrl.model.note.retailerId,
                orderBy: 'CompanyName',
                autoLoad: true,
                onLoaded: args => {$ctrl.model.customer = args.first;}
            });
        }
    }
    $ctrl.save = $ctrl.submit = function () {
        if ($ctrl.model.customerIds) {
            model.note.retailerIds = $ctrl.model.customerIds;
            bus.send('CreateRetailerNotes.json', $ctrl.model.note).then(function(response) {
                $rootScope.$emit('customerNoteSaved', $ctrl);
                $uibModalInstance.close($ctrl.model);
            });
        } else {
            if (model.customer) {
                $ctrl.model.note.retailerId = model.customer.id;
            }
            if($ctrl.model.note.id) {
                bus.send('UpdateRetailerNote.json', $ctrl.model.note).then(function (response) {
                    $rootScope.$emit('customerNoteSaved', $ctrl);
                    $uibModalInstance.close($ctrl.model);
                });
            } else {
                bus.send('CreateRetailerNote.json', $ctrl.model.note).then(function (response) {
                    $rootScope.$emit('customerNoteSaved', $ctrl);
                    $uibModalInstance.close($ctrl.model);
                });
            }
        }
    };
    $ctrl.delete = function() {
        $uibModalInstance.close($ctrl.model);
        return modals.confirm("Are you sure?", "Delete Note").result.then(function () {
            $ctrl.bus.send('DeleteRetailerNote.json', $ctrl.model.note).then(function (response) {
                $rootScope.$emit('customerNoteDeleted', $ctrl);
            });
        });
    }
    //$ctrl.vendors = new AutoQuery({
    //    url: 'QueryVendors.json?Active=1',
    //    orderBy: 'Label',
    //    autoLoad: true,
    //    pageSize: 100
    //})
    $ctrl.dismiss = function () {
        $uibModalInstance.dismiss();
    };
    $ctrl.toggleAlert = function() {
        let $ctrl = this;
        $ctrl.model.note.alert ? $ctrl.model.note.alert = false : $ctrl.model.note.alert = true;
    }
    $ctrl.findRetailers = function(val) {
        let $ctrl = this;
        let url = `/QueryRetailersSearch.json?Take=5&Status=Active&Search=${val}&OrderBy=CompanyName`; //
        console.log('QueryRetailersSearch.$item', url);
        return $ctrl.bus.send(url).then((res) => res.data.results);
    };
}

const CustomerNotePrompt =  {
    open(options) {
        return modals.open(angular.extend({
            size: 'md',
            // placement: 'right',
            //backdrop: false,
            templateUrl: templateUrl,
            resolve: {
                options: () => options
            },
            controller: CustomerNotePromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};


export default CustomerNotePrompt;